/**
 * Fired (on `window`) to request opening the delivery-address modal from
 * anywhere in the storefront tree without prop-drilling. The `_storefront`
 * route listens for it; the courier/pickup map "Enter the address" CTA
 * dispatches it.
 */
export const OPEN_DELIVERY_ADDRESS_MODAL_EVENT =
	"dransay:open-delivery-address-modal";
